module.exports = __webpack_public_path__ + "static/media/meta.959e0bac.jpg";